import React, { useCallback, useEffect, useState } from 'react'
import apiClient from '../../services/api'
import { useToast } from '../../context/ToastContext'
import LoadingSpinner from '../../components/LoadingSpinner'

const AdminSubscribers = () => {
  const [subs, setSubs] = useState([])
  const [loading, setLoading] = useState(true)
  const { addToast } = useToast()

  const load = useCallback(async () => {
    try {
      const res = await apiClient.get('/api/cms/subscribers')
      setSubs(res.data)
    } catch (e) { addToast('Error loading subscribers', 'danger') } finally { setLoading(false) }
  }, [addToast])

  useEffect(() => {
    const initialLoad = async () => {
      try {
        const res = await apiClient.get('/api/cms/subscribers')
        setSubs(res.data)
      } catch (e) {
        addToast('Error loading subscribers', 'danger')
      } finally {
        setLoading(false)
      }
    }

    initialLoad()
  }, [addToast])

  const remove = async (id) => {
    if (!window.confirm('Remove subscriber?')) return
    await apiClient.delete(`/api/cms/subscribers/${id}`)
    addToast('Subscriber removed', 'success')
    load()
  }

  if (loading) return <LoadingSpinner />

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h2>Subscribers</h2>
          <p>
            Review newsletter signups in one place and prune outdated contacts without leaving the admin panel.
          </p>
        </div>
      </div>

      <div className="admin-note mb-3">{subs.length} subscriber{subs.length === 1 ? '' : 's'} saved</div>

      <div className="table-responsive">
        <table className="table table-striped">
          <thead><tr><th>Email</th><th>Joined</th><th>Action</th></tr></thead>
          <tbody>
            {subs.map(s => (
              <tr key={s._id}>
                <td>{s.email}</td>
                <td>{new Date(s.createdAt).toLocaleString()}</td>
                <td><button className="btn btn-sm btn-danger" onClick={() => remove(s._id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AdminSubscribers
